module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.item.hidden) ? _c('div', [(_vm.hasOneShowingChild(_vm.item.children, _vm.item) && (!_vm.onlyOneChild.children || _vm.onlyOneChild.noShowingChildren) && !_vm.item.alwaysShow) ? [(_vm.onlyOneChild.Ischecked) ? _c('app-link', {
    attrs: {
      "to": _vm.onlyOneChild.permissionCode
    }
  }, [_c('el-menu-item', {
    class: {
      'submenu-title-noDropdown': !_vm.isNest
    },
    attrs: {
      "index": _vm.onlyOneChild.permissionCode
    }
  }, [_c('item', {
    attrs: {
      "icon": _vm.onlyOneChild.iconCls || (_vm.item.permissionName && _vm.item.iconCls),
      "title": _vm.onlyOneChild.permissionName
    }
  })], 1)], 1) : _vm._e()] : _c('el-submenu', {
    ref: "subMenu",
    attrs: {
      "index": _vm.item.permissionCode,
      "popper-append-to-body": ""
    }
  }, [_c('template', {
    slot: "title"
  }, [(_vm.item.Ischecked) ? _c('item', {
    attrs: {
      "icon": _vm.item.permissionName && _vm.item.iconCls,
      "title": _vm.item.permissionName
    }
  }) : _vm._e()], 1), _vm._v(" "), _vm._l((_vm.item.children), function(child) {
    return _c('sidebar-item', {
      key: child.permissionCode,
      staticClass: "nest-menu",
      attrs: {
        "is-nest": true,
        "item": child,
        "base-path": child.permissionCode
      }
    })
  })], 2)], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.store/vue-loader@11.3.4/~/vue-loader/lib/template-compiler?{"id":"data-v-2438f683"}!./~/.store/vue-loader@11.3.4/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sidebar/SidebarItem.vue
// module id = 1887
// module chunks = 1